export default __webpack_public_path__ + "static/media/slider2.675b194a.jpg";